export default __webpack_public_path__ + "static/media/AlignBottom.c8bd803f.svg";